export default __webpack_public_path__ + "static/media/black-card-diagonal.af17275a.svg";